import { styled } from "@mui/system";
import { Box, BoxProps, Typography } from "@mui/material";

const ErrBox = styled(Box)<BoxProps>(({ theme }) => ({
	maxHeight: "300px",
	overflow: "scroll",
}));

interface ErrorBoxProps {
	errorType: string;
	errorMessage: string;
	errorDetail: string;
}

const ErrorBox = ({ errorType, errorMessage, errorDetail }: ErrorBoxProps) => {
	return (
		<ErrBox>
			<Typography variant="h2" paragraph={true}>
				Error - {errorType}: {errorMessage}
			</Typography>{" "}
			<br />
			<Typography variant="body1">{errorDetail}</Typography>
		</ErrBox>
	);
};

export default ErrorBox;
